import { createTypes } from 'redux-create-types';
import { fromType, } from 'kreighter';

const namespace = 'chat';

export const chatActions = createTypes([
    'create',
    'addMessage',
], namespace);

export const chatActionsCreators = {
    create: fromType(chatActions.create, ['chat']),
    addMessage: fromType(chatActions.addMessage, ['message', 'chatId']),
}
